import { exportPDF } from "@api/stores/costs/exportPDF/path";
import { stats } from "@api/stores/costs/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/costs/`;
const pathById = `${pathBase}:costId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const costs = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  stats,
  exportPDF,
};
